import ApiClient from "../helpers/ApiClient";


export const addData = async ({ job_title, platform_name, url }) => {
    try {
        const response = await ApiClient.post(`/Careers/addJobListing`,
            { job_title,platform_name, url },
            );
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getData = async () => {
    try {
        const response = await ApiClient.get(`/Careers/getJobListing`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}


export const editData = async ({ id, job_title, platform_name, url }) => {

    try {
        const response = await ApiClient.put(`/Careers/updateJobListing/${id}`,
            { job_title, platform_name, url },
            );
        console.log("response  edit", response);
        return response;
    } catch (error) {
        throw error;
    }
}


export const deleteData = async ({ id }) => {
    try {
        const response = await ApiClient.delete(`/Careers/deleteJobListing/${id}`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}